/* eslint-disable */
// import utils from '../utils'
import config from '@/config'
import store from '../store'
import utils from '@/utils'
import AccountService from '../service/account.service'

import { getCustomHeaders } from '@geekbang/time.sdk'

import {ajax} from 'gkSrc/utils/request'

// 自定义 headers
const requestHeaders = {
  'Content-Type': 'application/json'
}

export default function (options = {}) {
  options.withCredentials = options.withCredentials === false ? false : true
  options.headers = Object.assign({}, requestHeaders, getCustomHeaders(), options.headers)
  // options.host = process.env.NODE_ENV === 'development' ? '/' : options.host || config.baseHost
  options.host = options.host || config.baseHost

  store.commit('SET_PAGE_LOADING', true)

  return ajax(options).then(res => {
    store.commit('SET_PAGE_LOADING', false)
    return res
  }).catch(err => {
    store.commit('SET_PAGE_LOADING', false)
    // 需要登录的接口，未登录时自动跳转到登录页面
    try {
      if (err.api === 1) {
        if (options.signin && err.code === -2021) {
          if (options.extra) {
            utils.storage.set('pageAction', {
              options: options.extra
            })
          }
          utils.storage.set('loginAction', {
            options: options
          })
          utils.login()
        }
      } else {
        if (err.error.response.status === 452) {
          store.commit('OFFLINE_MODAL_STATUS', true)
          AccountService.logout()
        }
      }
    } catch (error) {}

    return Promise.reject(err)
  })
}
